import React from 'react';
import { Provider } from 'react-redux';
import TestWidget from 'custom-tables/js/components/TestWidget/container';

/**
 * A Provider is used to wrap the "entry point" component for a React widget with a Redux Provider,
 * which is used to provide access to the Redux store.
 *
 * The "data" prop will contain any "data-" attributes added to the DOM element that the React widget will be rendered into.
 *
 * The Provider can also contain any "react-router" logic that may be required by a component.
 */

const TestWidgetProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <TestWidget data={data} />
        </Provider>
    );
};

export default TestWidgetProvider;
